import { SETCARTCOUNT, SETCARTDATA, SETCARTTOTALPRICE, SETCARTOPENSTATUS } from "../redux/features/CartData";
import { CheckIsMeal } from "./CustomizedCalculation/MealPrice";
import { GetTotalPrice } from "./GetTotalPrice";
import { TaxCalcualate } from "./TaxCalculate";
import Konsole from "./konsole/Konsole";
// import checkItemType from "./checkItemType";

import { Dispatch } from 'redux'

const DecrementItemData = (data: any, cardData: any, disPatch: Dispatch, itemCount: number, taxdata?: any) => {
  const index = cardData.indexOf(data);
  const TaxData = TaxCalcualate(taxdata, Number(data.sub_total) - Number(data.web_price), 1);
  Konsole.log("datadatat", data);
  if (data.quantity == 1) {
    cardData.splice(index, 1);
    const itemCountVal = itemCount - data.quantity;
    disPatch(SETCARTCOUNT(itemCount - data.quantity));
    if (itemCountVal == 0) {
      disPatch(SETCARTOPENSTATUS(false))
    }
  } else {
    // @@ comment for remove feature of copy duplicate
    // if (checkItemType(data) != 3) {
    //   cardData.splice(index, 1);
    //   disPatch(SETCARTCOUNT(itemCount - data.quantity));
    // } else
    //  {
    // for redux serial error
    data['textdata_for_page'] = '';

    // for redux serial error
    data["quantity"] = Number(data.quantity) - 1;
    data["sub_total"] = Number(data.sub_total);
    // console.log("_fromAdOn",fromAdOn)
    // data["total_price"] = Number(data.total_price) - Number(data?.customize_status == 1 ? data?.sub_total : data.price)
    data['total_price'] = parseFloat(data.total_price) - parseFloat((data?.customize_status == 1 || CheckIsMeal(data?.is_meal) || data?.from_ad_on===true) ? data.sub_total : data?.price);
    //  - TaxData.fixedTax - (Number(data.price) * TaxData.percentageTax) / 100;
    const TaxData = TaxCalcualate(taxdata, Number(data.total_price), Number(data.quantity) - 1);
    data["tax_rate_list"] = TaxData.taxArray;
    cardData.splice(index, 1, data);
    const itemCountVal = itemCount - 1;
    disPatch(SETCARTCOUNT(itemCount - 1));
    if (itemCountVal == 0) {
      disPatch(SETCARTOPENSTATUS(false))
    }
  }

  disPatch(SETCARTDATA(cardData));
  disPatch(SETCARTTOTALPRICE(GetTotalPrice(cardData)));

  if (cardData?.length) {
    sessionStorage.setItem("items", JSON.stringify(cardData));
  } else {
    sessionStorage.removeItem("items");
    // disPatch(SETCARTCOUNT(0));
  }
};

export default DecrementItemData;
